import React from 'react'

const Dashboard = () => {
  return (
    <div>
      <h1 className="d-flex justify-content-center">This Is Dashboard</h1>
    </div>
  )
}

export default Dashboard
